import { useEffect, useState } from 'react'
import Button from '../../components/Button'
import Checkbox from '../../components/Checkbox'
import TextInput from '../../components/TextInput'
import { useForm } from 'react-hook-form'
import MeasurementForm from './measurement-form'
import { useGetCurrentMemberQuery, useUpdateMemberProfileMutation } from '../../graphql'
import LoadingIndicator from '../../components/LoadingIndicator'
import { useTranslation } from 'react-i18next'
import avatar_placeholder from 'src/assets/images/avatar-placeholder.png'

const ProfileScreen = () => {

    const { data: memberData, loading } = useGetCurrentMemberQuery({
        onCompleted(data) {

        }
    })
    const lastMeasurement = memberData?.getCurrentMember?.measurement
    const [selectedLevel, setSelectedLevel] = useState<string>()
    const [updatingProfile, setUpdatingProfile] = useState(false);

    const [updateProfile] = useUpdateMemberProfileMutation({
        onCompleted() {
            window.location.reload();
        }
    })

    const getDefaultValues = () => {
        return {
            name: memberData?.getCurrentMember?.name,
            gender: memberData?.getCurrentMember?.gender,
            birthdate: new Date(memberData?.getCurrentMember!.birthdate || 0).toISOString().substring(0, 10),
            address: memberData?.getCurrentMember?.address
        }
    }
    const { register, handleSubmit, formState: { errors, isDirty }, reset, setValue, watch } = useForm({
        defaultValues: getDefaultValues(),
        resetOptions: {
            keepValues: true
        }
    });

    const formValues = watch();

    const onSaveProfile = async (data: Partial<any>) => {
        setUpdatingProfile(true)
        await updateProfile({
            variables: {
                input: {
                    gender: data.gender,
                    name: data.name,
                    address: data.address,
                    birthdate: data.birthdate
                }
            }
        })

    }

    useEffect(() => {
        reset(getDefaultValues());
    }, [memberData?.getCurrentMember, memberData])

    const onInvalid = (e: any) => {
    }

    const { t } = useTranslation();

    if (loading) {
        return <section>
            <h1 className='light-orange relative'>{t("Profile")}</h1>
            <LoadingIndicator />
        </section>
    }

    return (
        <section>
            <form onSubmit={handleSubmit(onSaveProfile, onInvalid)}>
                <article>
                    <h1 className='light-orange relative'>{t("Profile")}</h1>
                    <nav>
                        <Button loading={updatingProfile} disabled={!isDirty} type='submit' sm fontLight>{t("save_changes")}</Button>
                    </nav>

                    <div className='flex items-center gap-4'>
                        <img
                            src={memberData?.getCurrentMember?.picture || avatar_placeholder}
                            alt='profile'
                            className='w-[60px] h-[60px] object-contain rounded-full ' />
                        <div>
                            <p className='text-dark text-md font-semibold'>{memberData?.getCurrentMember?.name}</p>
                            <p className='gray text-base font-medium'>{t("member")}</p>
                            <p className='gray text-base font-medium'>{memberData?.getCurrentMember?.email}</p>
                        </div>
                    </div>
                </article>

                <hr className='border-[#D0D5DD] w-full my-6 hidden md:block' />


                <article>
                    <div className='flex divide-x-reverse md:divide-x divide-x-[#D0D5DD] md:gap-x-10 flex-col md:flex-row mt-4 md:mt-0'>
                        <div className='basis-2/3'>

                            <h1 className='dark-purple'>{t("personal_information")}</h1>
                            <div className='flex justify-between flex-col md:flex-row gap-6 md:gap-3'>
                                <div className='flex gap-6 flex-col'>
                                    <div className='space-y-2 md:space-y-0'>
                                        <p className='gray text-base font-medium'>{t("full_name")}</p>
                                        <TextInput error={Boolean(errors.name)}
                                            inputProps={register('name', {
                                                required: true,
                                            })}
                                            sm />
                                    </div>

                                    <div>
                                        <p className='gray text-base font-medium'>{t("address")}</p>
                                        <TextInput inputProps={
                                            register('address', {
                                                required: false
                                            })
                                        } sm />
                                    </div>

                                    {memberData?.getCurrentMember?.email && <div className='space-y-2 md:space-y-0'>
                                        <p className='gray text-base font-medium'>{t("email_address")}</p>
                                        <p className='text-base'>
                                            {memberData?.getCurrentMember?.email}
                                        </p>
                                        {/* <TextInput
                                            value={memberData?.getCurrentMember?.email}
                                            inputProps={{ disabled: true }}
                                            // error={Boolean(errors.email)}
                                            // inputProps={register('email', {
                                            //     required: true,
                                            //     pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                            // })}
                                            sm /> */}
                                    </div>}

                                    <div className='space-y-2 md:space-y-0'>
                                        <p className='gray text-base font-medium'>{t("date_of_birth")}</p>
                                        <p className='text-base'>
                                            <TextInput inputProps={{ ...register("birthdate") }} type='date' />
                                        </p>

                                        {/* <TextInput
                                            error={Boolean(errors.birthdate)}
                                            type="date"
                                            inputProps={register('birthdate', {
                                                required: true,
                                                valueAsDate: false
                                            })}
                                            sm /> */}
                                    </div>

                                </div>
                                <div className='flex gap-6 flex-col'>

                                    <div>
                                        <p className='gray text-base font-medium'>{t("phone")}</p>
                                        <p className='text-base' dir='ltr'>
                                            {memberData?.getCurrentMember?.phone_number?.substring(4)}
                                        </p>

                                        {/* <TextInput value={memberData?.getCurrentMember?.phone_number} sm /> */}
                                    </div>

                                </div>
                            </div>
                            <div className='space-y-2 pt-3'>
                                <p className='gray text-base font-medium'>{t("gender")}</p>
                                <div className='flex gap-x-3 md:gap-x-6'>
                                    <Checkbox label={t("Male")} checked={formValues.gender === 'MALE'} onChange={(e) => setValue('gender', 'MALE', { shouldDirty: true })} />
                                    <Checkbox label={t("Female")} checked={formValues.gender === 'FEMALE'} onChange={(e) => setValue('gender', 'FEMALE', { shouldDirty: true })} />
                                    <Checkbox label={t("Other")} checked={formValues.gender === 'OTHER'} onChange={(e) => setValue('gender', 'OTHER', { shouldDirty: true })} />
                                </div>
                            </div>

                        </div>


                        <div className='basis-1/2 mt-4 md:mt-0 md:ps-4'>

                            <h1 className='purple'>{t("Progression")}</h1>


                            <div className='gap-6 flex flex-col'>
                                <div className='space-y-2'>
                                    <label className='gray text-base font-medium'>{t("level")}</label>
                                    <div className='flex flex-wrap gap-2'>
                                        <Checkbox label={t("beginner")} checked={selectedLevel === 'beginner'} onChange={(e) => setSelectedLevel('beginner')} />
                                        <Checkbox label={t("intermediate")} checked={selectedLevel === 'intermediate'} onChange={(e) => setSelectedLevel('intermediate')} />
                                        <Checkbox label={t("advanced")} checked={selectedLevel === 'advanced'} onChange={(e) => setSelectedLevel('advanced')} />
                                    </div>
                                </div>

                                <div className='space-y-2'>
                                    <label className='gray text-base font-medium'>{t("Goals")}</label>
                                    <div className='space-y-2 w-fit'>
                                        <Checkbox label={t('Muscle Building')} />
                                        <Checkbox label={t('Fat Reduction')} />
                                        <Checkbox label={t('Cardio Health')} />
                                        <Checkbox label={t('Power Boost')} />
                                        <Checkbox label={t('Movement')} />
                                        <Checkbox label={t('Well-being')} />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </article>
                <hr className='border-[#D0D5DD] w-full my-6 hidden md:block' />
            </form>

            <MeasurementForm measurement={lastMeasurement || {}} />
        </section>
    )
}

export default ProfileScreen